export class NeoParametrizacionAliadoIntermediarioDTO {
    constructor(
      public idCliente: number,
      public idsTipoPersonaJuridica:number[]=[]
    ) {}
  }